module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "PT"
  }, [_vm._v("ED")]), _vm._v(" "), _c('p', {
    staticClass: "PIT"
  }, [_vm._v("Girls I have liked:")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Jenn Challener")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Aimee Eastwood")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Raina Korman")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Ms. Reidy")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Jennifer Love Hewitt (Okay, I was fourteen)")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Storm, Rogue, Jubilee, Jean Grey")]), _vm._v(" "), _c('p', {
    staticClass: "PTXb"
  }, [_vm._v("The lady behind the counter at Balducci’s")]), _vm._v(" "), _c('p', {
    staticClass: "PIT"
  }, [_vm._v("Girls I have loved:")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Heather Gannis")]), _vm._v(" "), _c('p', {
    staticClass: "PTXb"
  }, [_vm._v("Gaia Moore")]), _vm._v(" "), _c('p', {
    staticClass: "PIT"
  }, [_vm._v("Girls who have ripped out my cardiovascular muscle and squashed it under their feet:")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Heather Gannis")]), _vm._v(" "), _c('p', {
    staticClass: "PTXb"
  }, [_vm._v("Gaia Moore")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Anyone besides me sensing a pattern around here?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024a10c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part3.vue
// module id = 84
// module chunks = 0